module.exports = __webpack_public_path__ + "media/images/arrow-input-grey-20ebc3b248c9391f559ce3f506f09a29.png";